const tripRateTooltipStrings = {
  ratePerKilometer: "Sats for '{0}' pr km: {1}",
  ratePerPassenger: "Sats pr @.lower:(commonStrings.passenger)/km: {0}",
  minimumDrivingDistance: "Minste kjørelengde for refusjon: {0} km",
  splitKilometers: "Hver mottaker betaler for: {0} km",
  passengerCount: "@:commonStrings.passengerCount ",
  minimumDrivingDistanceWarning: "Minste kjørelengde for refusjon er ikke oppfylt for alle mottakere"
};

export default tripRateTooltipStrings;